import validate from "/home/jmcastillo/projects/external/diprofem-frontend-v2/node_modules/nuxt/dist/pages/runtime/validate.js";
import load_45cart_45items_45global from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/middleware/loadCartItems.global.js";
import normalize_45trailing_45slash_45global from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/middleware/normalize-trailing-slash.global.js";
import manifest_45route_45rule from "/home/jmcastillo/projects/external/diprofem-frontend-v2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  load_45cart_45items_45global,
  normalize_45trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "only-authenticated": () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/middleware/onlyAuthenticated.js"),
  "only-not-authenticated": () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/middleware/onlyNotAuthenticated.js"),
  "only-not-price-table-authenticated": () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/middleware/onlyNotPriceTableAuthenticated.js"),
  "only-price-table-authenticated": () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/middleware/onlyPriceTableAuthenticated.js")
}